import 'antd/dist/antd.css';
import './styles/worldcup2026-groups.css';

import './App.css';
import React from 'react';
import BaseLayout from '@layout/BaseLayout';
import Pages from '@pages/names';
import { connect } from 'react-redux';

import Login from '@pages/Login';
import FixtureEmbed from '@pages/FixtureEmbed';

const NoLayoutPages = {
  [Pages.Login]: Login,
  [Pages.FixtureEmbed]: FixtureEmbed,
};

const App = ({ page }) => {
  const Component = NoLayoutPages[page] ?? BaseLayout;
  return <Component />;
};
export const mapStateToProps = (state) => ({
  page: state.page,
});

export default connect(mapStateToProps)(App);
